import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/index.vue'
import Home from './views/home.vue'
import Notice from './views/notice.vue'
import System from './views/system.vue'
import Detail from './views/system-detail.vue'

import Internship from './views/Internship-progress.vue'
import InterInformation from './views/Internship-information.vue'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/notice',
      name: 'notice',
      component: Notice
    },
    {
      path: '/system',
      name: 'system',
      component: System,
    },
    {
      path: '/detail',
      name: 'detail',
      component: Detail,
    }, 
    {
      path: '/internship',
      name: 'Internship',
      component: Internship
    },
    {
      path: '/internship-information',
      name: 'InterInformation',
      component: InterInformation
    }
  ]
})